// Header Fixed JS
//
// Hiding or Showing Fx
//
// Nav Sticky Top Position Calculation Fx via .js-affix
//

var fn_header_sticky = function () {

    var body = $('body');
		var header = $('.header');

		var headerHeight = $('.header').outerHeight();
		var navAffixHeight = $('.js-affix').outerHeight();
		var navAffix = $('.js-affix');
		var toc = $('.nav-anchor__toc');

		var navBooks = $('.book-blocks-toc');


		// FN HEADER Fx
		// See; https://www.solodev.com/blog/web-design/bootstrap/build-a-fixed-top-navigation-that-disappears-as-users-scroll.stml
		var previousScroll = 0;
		$(window).scroll(function () {
			var currentScroll = $(this).scrollTop();

			if (currentScroll < 100) {
				showNav();
			} else if (currentScroll > 0 && currentScroll < $(document).height() - $(window).height()) {
				if (currentScroll > previousScroll) {
					hideNav();
					// > navAffix
					if ( $(navAffix).length ) {
						hideBook()
					}

				} else {
					showNav();
					// > navAffix
					if ( $(navAffix).length ) {
						showBook()
					}

				}
				previousScroll = currentScroll;
			}

			positionToc();

		});

		function hideNav() {
			$(header).removeClass("is-visible").addClass("is-hidden");

		}
		function showNav() {
			$(header).removeClass("is-hidden").addClass("is-visible");

		}


		// FN NAV BOOKs Fx
		function hideBook() {
			$(navAffix).css("top","0");
		}
		function showBook() {
			$(navAffix).css("top", (parseInt(headerHeight) / 10)+'rem');
		}

		// FN Compensate TOC (zapette)
		// 11rem shall be more or less NavBooks Height
		function positionToc() {
			if ( toc.length ) {

				if ( $(navBooks).length ) {
					toc.css("top", (parseInt(navAffixHeight) / 10)+'rem');

				} else {
					toc.css("top", "2.4rem");

				}

			}
			//
		}


};
